<template>
  <v-app-bar app style="background: #242423;" class="navbar">
    <router-link style="text-decoration: none" :to="{ name: 'Map' }">
      <v-toolbar-title class="ml-5" style="color: #f5cb5c; pointer: cursor;">
        <span class="headline">GEO-MAP</span>
        <span class="title font-weight-light ml-1">CODEC</span>
      </v-toolbar-title>
    </router-link>
    <v-spacer></v-spacer>
    <div class="hidden-xs-only mr-12">
      <v-btn v-if="userDetail" text class="emailDisplay" color="#cfdbd5">{{ userDetail.email }}</v-btn>
      <router-link style="text-decoration: none" :to="{ name: 'Login' }">
        <v-btn v-if="!userDetail" text color="#cfdbd5">Login</v-btn>
      </router-link>
      <router-link style="text-decoration: none" :to="{ name: 'SignUp' }">
        <v-btn v-if="!userDetail" text color="#cfdbd5">Sign Up</v-btn>
      </router-link>
      <v-btn v-if="userDetail" text color="#cfdbd5" @click.prevent="logOut">Log Out</v-btn>
    </div>

    <div class="hidden-sm-and-up mr-2">
      <v-menu left bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon color="#cfdbd5">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="userDetail">
            <router-link style="text-decoration: none" :to="{ name: 'Login' }">
              <v-btn text color="#000" style="font-size: 100%;">{{ userDetail.email }}</v-btn>
            </router-link>
          </v-list-item>
          <v-list-item v-if="!userDetail">
            <router-link style="text-decoration: none" :to="{ name: 'Login' }">
              <v-list-item-title>Login</v-list-item-title>
            </router-link>
          </v-list-item>
          <v-list-item v-if="!userDetail">
            <router-link style="text-decoration: none" :to="{ name: 'SignUp' }">
              <v-list-item-title>Sign Up</v-list-item-title>
            </router-link>
          </v-list-item>
          <v-list-item v-if="userDetail">
            <v-list-item-title @click.prevent="logOut">Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </v-app-bar>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Navbar',

  data () {
    return {
      userDetail: null
    }
  },

  created () {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.userDetail = user
      } else {
        this.userDetail = null
      }
    })
  },

  methods: {
    logOut () {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push({ name: 'Login' })
        })
    }
  }
}
</script>

<style lang="scss">
.navbar .emailDisplay {
  pointer-events: none;
}
</style>
